import { styled } from "styled-components";

export const RequestStatusFormWrapper = styled.div`
	.statusFlow {
		padding-block: 6px;
		padding-left: 24px;
		border-left: 2px solid #a8b1b4;
		border-radius: 2px;
		margin-bottom: 45px;
		position: relative;

		.statusFlow_item {
			color: #00525d;
			border: 1px solid #00525d;
			border-radius: 4px;
			padding: 8px 12px;
			margin-bottom: 16px;
			font-size: 14px;
			font-weight: 600;

			&.done {
				font-weight: 500;
				color: #8b9699;
				border: 1px solid #a8b1b4;
			}

			&::before {
				content: "";
				width: 13px;
				height: 13px;
				border-radius: 100%;
				position: absolute;
				left: -7px;
				background: #00525d;
			}

			&.done::before {
				background: #a8b1b4;
			}

			&:last-child {
				margin-bottom: 0;
			}
		}
	}
`;
